import React from 'react'
import { Grid, Typography } from '@mui/material'
import Image from 'next/image'
import useStyles from './Styles'
import { Box } from '@mui/system'
import LinkIcon from 'src/assets/svgs/campaigns/LinkIconWhite.svg'
import Avatar from '@mui/material/Avatar'
import Link from 'next/link'
import Img from 'src/assets/images/campaigns/imgHeader.jpg'
import ImgMobile from 'src/assets/images/campaigns/mobileHeader.jpg'
import Matrix from './matrix/Matrix'
import { campaignHeroCard } from 'src/types/components/shared/atom/index'
import { RecentPressI } from 'src/types/store/index'
interface Props {
  zenMode: boolean
  heroHeaderCard: campaignHeroCard
  campaignPartner: RecentPressI[]
}
function Content({ zenMode, heroHeaderCard, campaignPartner }: Props) {
  const { classes } = useStyles()
  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.campaignsContainer}>
          <div className={classes.root}>
            <Grid container>
              <Grid item md={12} sm={12} xs={12}>
                <div style={{ position: 'relative' }}>
                  <Box
                    className={`${classes.imgBox} ${
                      zenMode && classes.zenModeImg
                    }`}
                  >
                    <Box className={classes.imgDesc}>
                      {/* <div className={classes.btnContainer}>
                        <ButtonComponent
                          type="contained"
                          text={heroHeaderCard.button.content}
                          className={classes.recommendBtn}
                        />
                      </div> */}
                      <Typography className={classes.date}>
                        {' '}
                        {heroHeaderCard.date}
                      </Typography>
                      <Box className={classes.linkTitle}>
                        <Typography className={classes.title}>
                          {' '}
                          {heroHeaderCard.heading}
                        </Typography>
                      </Box>
                      <Box className={classes.brandInfo}>
                        <Avatar
                          className={classes.avatar}
                          src={heroHeaderCard.brandAvatar.src}
                          aria-label="companuy logo"
                        ></Avatar>
                        <Box className={classes.linkTitle}>
                          <Typography className={classes.partners} pl={4}>
                            {' '}
                            {heroHeaderCard.brandName}
                          </Typography>
                          <Link
                            href={
                              heroHeaderCard.link ? heroHeaderCard.link : '#'
                            }
                          >
                            {' '}
                            <Image
                              src={LinkIcon}
                              alt="image"
                              aria-label="Link button"
                            />
                          </Link>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{ display: { md: 'flex', sm: 'none', xs: 'none' } }}
                      className={classes.heroImg}
                    >
                      {!zenMode && <Image src={Img} alt="image" />}
                    </Box>
                    <Box
                      sx={{ display: { md: 'none', sm: 'flex' } }}
                      className={classes.heroImg}
                    >
                      {!zenMode && <Image src={ImgMobile} alt="image" />}
                    </Box>
                  </Box>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <Box
        className={`${classes.matrixBox} ${zenMode && classes.zenModeWithBg}`}
      >
        <Box className={classes.matrixTop}>
          {}
          <Matrix zenMode={zenMode} campaignPartnerData={campaignPartner} />
        </Box>
      </Box>
    </>
  )
}

export default Content
